import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { registrationLists } from '../../redux/registration_block/registrationActions';
import RegistrationItem from './RegistrationItem';
import './Registration.css';

const Registration = () => {
  const dispatch = useDispatch();
  const registration = useSelector((state) => state.Registration);
  useEffect(() => {
    if (registration.length === 0) {
      dispatch(registrationLists());
    }
  });

  return (
    <div className="container mt-3">
      <div>
        <h1 className="homepage-heading">Register Yourself at Business Xchange As</h1>
      </div>
      <ul className="exchange-list-conatiner">
        <div className="grid-container">
          {registration.map((registration) => (
            <RegistrationItem
              key={registration.id}
              registration={registration}
            />
          ))}
        </div>
      </ul>
    </div>
  );
};

export default Registration;
